<template>
    <div>
        <select ref="select" class="create-input">
            <option value="">{{ placeholder }}</option>
        </select>
    </div>
</template>

<script setup>
import { ref, onMounted, watch, onBeforeUnmount } from 'vue';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import '@/assets/css/select2-custom.css';

// Props
const props = defineProps({
    modelValue: [String, Number],
    options: {
        type: Array,
        required: true
    },
    placeholder: {
        type: String,
        default: 'Seleccione una opción'
    }
});

// Emit event to parent
const emit = defineEmits(['update:modelValue']);

// Refs
const select = ref(null);

onMounted(() => {
    // Initialize select2 when component is mounted
    $(select.value)
        .select2({
            data: props.options,
            placeholder: props.placeholder
        })
        .on('change.select2', function () {
            const selectedValue = $(select.value).val();
            emit('update:modelValue', selectedValue); // Emit selected value to parent
        });

    // Set initial value
    $(select.value).val(props.modelValue).trigger('change');
});

// Watch for changes in modelValue and update select2 value
watch(() => props.modelValue, (newVal) => {
    $(select.value).val(newVal).trigger('change');
});

// Watch for changes in options and update select2 data
watch(() => props.options, (newOptions) => {
    $(select.value).empty().select2({ data: newOptions });
});

// Cleanup on unmount
onBeforeUnmount(() => {
    $(select.value).off('change.select2').select2('destroy');
});
</script>

<style scoped>
.create-input {
    width: 100%;
    padding: 5px;
    font-size: 14px;
}
</style>
